// Vendors
import React, { useState } from 'react';
import axios from 'axios';
import qs from 'querystring';

// Components
import { AccountForm, DocumentW9 } from './components';
import { Loader } from '../components';

const MyAccount = () => {
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState('account-home');
  const [mainNotice, setMainNotice] = useState({ type: '', message: '' });
  const [showMainNotice, setShowMainNotice] = useState(false);
  const [userMeta, setUserMeta] = useState(window.wlPipUserMeta);
  const [requiredFieldsOK, setRequiredFieldsOK] = useState(true);
  const contractUrl = window.wlPIPContractUrl.url;

  const getPageTitle = () => {
    switch (view) {
      case 'account-form':
        return `My Account: Edit Details`;
      case 'document-w9':
        return `My Account: W-9 Document`;
      case 'account-home':
      default:
        return 'My Account';
    }
  };

  const checkRequiredFields = () => {
    let {
      first_name,
      last_name,
      address,
      company,
      phone,
      city,
      state,
      zip_code
    } = userMeta;

    if (
      !first_name ||
      !last_name ||
      !address ||
      !company ||
      !phone ||
      !city ||
      !state ||
      zip_code.replace(/\D/gi, '').length !== 5 ||
      phone.replace(/\D/gi, '').length !== 10
    ) {
      setRequiredFieldsOK(false);
      return false;
    }

    setRequiredFieldsOK(true);
    return true;
  };

  const handleChangeView = (view) => {
    setLoading(true);
    setShowMainNotice(false);

    setTimeout(() => {
      setLoading(false);
      view ? setView(view) : setView('account-home');
    }, Math.random() * 250);
  };

  const handleInputChange = (event) => {
    let newUserMeta = userMeta;
    newUserMeta[event.currentTarget.name] = event.currentTarget.value;
    setUserMeta({ ...newUserMeta });

    checkRequiredFields();
  };

  const handleSaveUserMeta = () => {
    setLoading(true);

    axios
      .post(
        window.wlPipConfig.ajaxUrl,
        qs.stringify({ action: 'wl_pip_save_user_meta', ...userMeta })
      )
      .then(({ data: { success, data } }) => {
        setMainNotice({
          type: success ? 'success' : 'error',
          message: data.message
        });

        setShowMainNotice(true);

        if (data.user_meta_fields) {
          setUserMeta(data.user_meta_fields);
        }

        setTimeout(() => setLoading(false), 250);
      })
      .catch((error) => {
        setMainNotice({
          type: 'error',
          message: error
        });
        setShowMainNotice(true);

        setTimeout(() => setLoading(false), 250);
      });
  };

  const updateSpecificProjectDataProperty = (key, value) => {
    let newUserMeta = userMeta;

    if (newUserMeta.hasOwnProperty(key)) {
      newUserMeta[key] = value;
      setUserMeta({ ...newUserMeta });
    }
  };

  const handleLogout = () => {};

  if (loading) return <Loader />;

  return (
    <>
      {view !== 'account-home' && (
        <h5
          className="edit-form__back"
          onClick={() => {
            handleChangeView();
          }}
        >
          Back to My Account Overview
        </h5>
      )}

      {/* Show view's title */}
      <h1 className="u--color-blue-dark">{getPageTitle()}</h1>

      {/* Show notice message */}
      {showMainNotice === true && (
        <div
          className={`notice notice--${mainNotice.type}`}
          role="alert"
          style={{ maxWidth: '600px' }}
        >
          {mainNotice.message}
        </div>
      )}

      {view === 'account-form' && (
        <AccountForm
          userMeta={userMeta}
          requiredFieldsOK={requiredFieldsOK}
          handleInputChange={handleInputChange}
          handleChangeView={handleChangeView}
          handleSaveUserMeta={handleSaveUserMeta}
        />
      )}
      {view === 'document-w9' && (
        <DocumentW9
          userMeta={userMeta}
          handleChangeView={handleChangeView}
          handleSaveUserMeta={handleSaveUserMeta}
          updateSpecificProjectDataProperty={updateSpecificProjectDataProperty}
        />
      )}

      {view === 'account-home' && (
        <div id="my-account">
          <div className="grid u--font-size-lg" style={{ maxWidth: '600px' }}>
            <div className="grid__col-xs-12 u--margin-bottom-20">
              <button
                id="pip-my-profile"
                className={`btn btn--gold btn--outline btn--has-arrow module-hover-root ${
                  requiredFieldsOK ? 'btn--pip-complete' : ''
                }`}
                onClick={() => handleChangeView('account-form')}
              >
                <span className="btn__content">
                  <span className="btn__text">My Profile</span>
                  <span className="btn__arrow arrow arrow--black"></span>
                </span>
              </button>
            </div>
            <div className="grid__col-xs-12 u--margin-bottom-20">
              <button
                id="pip-add__w9"
                className={`btn btn--gold btn--outline btn--has-arrow module-hover-root ${
                  userMeta.user_builder_w9 || userMeta.has_uploaded_w9
                    ? 'btn--pip-complete'
                    : ''
                }`}
                onClick={() => handleChangeView('document-w9')}
              >
                <span className="btn__content">
                  <span className="btn__text">Upload W-9</span>
                  <span className="btn__arrow arrow arrow--black"></span>
                </span>
              </button>
            </div>
            {contractUrl != false && (
              <div className="grid__col-xs-12 u--margin-bottom-20">
                <a href={contractUrl} className="link" target="_blank">
                  <strong>View Signed Builder Contract</strong>
                </a>
              </div>
            )}
            <div className="grid__col-xs-12 u--margin-top-20">
              <a
                href="/wp-login.php?action=logout"
                id="pip-user-logout"
                className="btn btn--blue btn--outline btn--md module-hover-root u--margin-top-30"
              >
                <span className="btn__content">
                  <span className="btn__text">Log out</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MyAccount;
